import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const PostbackTestActions = {
    visibleModal() {
        dispatch({
            type: AppConstants.POSTBACK_TEST_MODAL_VISIBLE
        });
    },

    hiddenModal() {
        dispatch({
            type: AppConstants.POSTBACK_TEST_MODAL_HIDDEN
        });
    },

    test(params) {
        dispatch({
            type: AppConstants.POSTBACK_TEST_START_LOADING
        });

        api.testPostbacks(params)
            .then(data => {
                dispatch({
                    type  : AppConstants.POSTBACK_TEST_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type  : AppConstants.POSTBACK_TEST_FAIL,
                        error : err.error
                    });
                });
            });
    },

    clear() {
        dispatch({
            type: AppConstants.POSTBACK_TEST_CLEAR
        });
    }
};

export default PostbackTestActions;
